module.exports = __webpack_public_path__ + "img/zone-blue.562bc0e3.png";